import React, { Component, Fragment } from 'react';
import { cloneDeep } from 'lodash';
import { Col, Form, Input, Modal, Radio, Row, Select, Upload } from 'antd';
import {DollarCircleOutlined, InboxOutlined} from '@ant-design/icons';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class ProductRowForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: []
        };

        this.formRef = React.createRef();
    }

    handleCategory = () => {
        this.formRef.current.setFieldsValue({ subCategory: undefined });
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            const formData = new FormData();

            formData.append('title', values.title);
            this.props.onSubmit(formData);
        });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);

        this.formRef.current.setFieldsValue(cloneData);

        this.setState({ editMode: !!cloneData.id });
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { fileList, editMode } = this.state;


        return (
            <Modal
                title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>

                        <Col xs={24} md={12}>
                            <Form.Item
                                name="title"
                                label={Resources.title}
                                rules={Rules.required}
                            >
                                <Input
                                    type="text"
                                    dir="ltr"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
};

export default ProductRowForm;